"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.derivationsArray = void 0;
exports.derivationsArray = [
    "En domicilio con monitoreo",
    "Evaluación en verde VMD",
    "Evaluación en amarillo",
    "Evaluación en rojo",
    "Traslado protocolo pandemia",
];
